import emailjs from "@emailjs/browser";
import { notification } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { Typewriter } from "react-simple-typewriter";
import "./contact-form.scss";

const ContactForm = () => {
  const form = useRef();

  const [done, setDone] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    if (
      e?.target[0].value?.trim()?.length > 0 &&
      e?.target[1].value?.trim()?.length > 0 &&
      e?.target[2].value?.trim()?.length > 0
    ) {
      notification.info({
        key: "1",
        style: { fontSize: "6rem" },
        description: "Please wait while we are sending the mail.",
        duration: 2,
        closeIcon: false,
      });

      // using email js for email service
      emailjs
        .sendForm(
          "service_sq7wp14",
          "template_n09jydl",
          form.current,
          "tRNIFef8g73-gfXwF"
        )
        .then(
          (result) => {
            console.log(result.text);
            setDone(true); // for showing form submit message
            e.target.reset(); // for resetting form after clicking on send button
          },
          (error) => {
            console.log(error.text);
          }
        );
    } else {
      notification.error({
        key: "1",
        style: { fontSize: "6rem" },
        description: "Please fill all the fields.",
        duration: 2,
        closeIcon: false,
      });
    }
  };

  useEffect(() => {
    if (done) {
      notification.success({
        key: "1",
        style: { fontSize: "6rem" },
        description: "Thank you for contacting me. I'll get back to you soon.",
        duration: 3,
        closeIcon: false,
      });
    }
    setDone(false);
  }, [done]);

  return (
    <div className="contact-form">
      <div className="header">
        <Typewriter words={["Let's get in touch!"]} loop={true} />
      </div>

      <div className="form-details">
        <form ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            name="user_name"
            className="user"
            placeholder="Enter your Full Name"
          />
          <input
            type="text"
            name="user_email"
            className="user"
            placeholder="Enter your E-mail"
          />
          <textarea
            name="message"
            className="user"
            placeholder="Enter your message..."
          />
          <input type="submit" value="Send" className="form-submit-btn" />
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
